export const environment = {
  production: false,
  apiUrl: "https://my.staging.studelites.com",
  isTokenAuth: true
};
